import React from 'react';
import { Modal, Button, Icon, Table, Spin, InputNumber, Tag } from 'antd';

import Pedidos from '../../services/Pedidos';
import { openNotification } from '../../util/notificaciones';

import moment from 'moment';
import 'moment/locale/es';
moment.locale('es');


export default class EditarPedidoRealizado extends React.Component {

    state = {
        cargando: false,
        articulosPedido: [],
        articulosPedidoOriginal: [],
        paginaSiguiente: 1,
        paginacion: {},
        arrEditArticulos: [],
        total_articulos: [],
        paginas_vistas: [1],
        bloquearBtnEditar: true,
        mostrarModalModificados: false,
        pedidoModificado: null,
    }

    /**
     * Comportamiento del modal cada vez que se despliega.
     * Se aplica al editar o visualizar datos
     * @param: prevProps. propiedades que tenia el componente antes de ser
     * desplegado
     * @return: nada.
     */
    componentDidUpdate = (prevProps) => {
        let state = { ...this.state }
        if ((this.props.pedido_selected !== prevProps.pedido_selected)) {
            if (this.props.tipo_modal === "Editar") {
                if (this.props.pedido_selected !== null) {
                    state.articulosPedido = [];
                    state.articulosPedidoOriginal = [];
                    state.articulosPedido = [];
                    state.cargando = true;
                    state.bloquearBtnEditar = true;
                    this.setState(state, () => {
                        Pedidos.CargarArticulosPedidoPag(this.props.pedido_selected.id).then(response => {
                            state.paginacion = {
                                current: state.paginaSiguiente,
                                total: response.data.count,
                                onChange: this.handlePaginaChange,
                                pageSize: 10,
                                showTitle: false
                            }

                            state.paginas_totales = response.data.count;
                            response.data.results.forEach((item, index) => {
                                if(item.cantidad_solicitada === 0)
                                {
                                    item.status = 'Cancelado'
                                }

                                if(item.status === '' || item.status === null){
                                    item.cantidad_recibida = 0
                                    item.cantidad_original = item.cantidad_solicitada
                                    item.status = 'Creado'
                                }
                            });

                            state.total_articulos.push(response.data.results);
                            let count_pages = Math.ceil((response.data.count) / 10);
                            for (let index = 1; index < count_pages; index++) {
                                state.total_articulos.push(null)
                            }

                            state.articulosPedido = response.data.results;
                            state.articulosPedidoOriginal = response.data.results;
                            state.cargando = false;
                            this.setState(state);
                        }).catch(err => {
                            this.setState({ cargando: false })
                            openNotification("No se han podido cargar los artículos del pedido.", "Error al cargar artículos", false)
                        });
                    });
                }
            }
        }
    }

    /**
     * Función que se ejecuta cuando se da clic en página siguiente
     * @param: paginaSiguiente. valor de la página siguiente
     * @return: nada. se establece un nuevo valor para la el texto a filtrar.
     */
    handlePaginaChange = (paginaSiguiente) => {
        let state = { ...this.state };
        state.cargando = true;
        state.paginaSiguiente = paginaSiguiente;
        state.cargando = true;
        state.bloquearBtnEditar = true;
        state.total_articulos[state.pagina_actual - 1] = [...state.articulosPedido];
        this.setState(state, () => {
            if (state.total_articulos[paginaSiguiente - 1] === null) {
                Pedidos.CargarArticulosPedidoPag(this.props.pedido_selected.id, paginaSiguiente).then(response => {
                    state.cargando = false;
                    state.paginacion = {
                        current: state.paginaSiguiente,
                        total: response.data.count
                    }

                    state.pagina_actual = paginaSiguiente;
                    state.paginas_totales = response.data.count;
                    response.data.results.forEach((item, index) => {
                        if(item.cantidad_solicitada === 0)
                        {
                            item.status = 'Cancelado'
                        }

                        if(item.status === '' || item.status === null){
                            item.cantidad_recibida = 0
                            item.cantidad_original = item.cantidad_solicitada
                            item.status = 'Creado'
                        }
                    })

                    state.paginas_vistas.push(paginaSiguiente)
                    state.articulosPedido = response.data.results;
                    state.articulosPedidoOriginal = response.data.results;
                    this.setState(state);
                }).catch(err => {
                    this.setState({ cargando: false })
                    openNotification("No se han podido cargar los artículos del pedido.", "Error", false)
                })
            } 
            else {
                state.cargando = false;
                state.bloquearBtn = false;
                state.paginacion = {
                    current: state.paginaSiguiente,
                }
                state.pagina_actual = paginaSiguiente;
                state.articulosPedido = [...state.total_articulos[paginaSiguiente - 1]];
                state.articulosPedidoOriginal = [...state.total_articulos[paginaSiguiente - 1]];
                this.setState(state)
            }
        })
    }

     /**
     * Función que se manda a llamar cuando se cierra el modal
     * de planeación de un pedido.
     */
     handleCancel = () => {
        let state = { ...this.state };

        state.bloquearBtnEditar = true;
        state.pagina_actual = 1;
        state.paginaSiguiente = 1;
        state.articulosPedido = [];
        state.articulosPedidoOriginal = [];
        state.paginacion = {};
        state.arrEditArticulos = [];
        state.total_articulos = [];
        state.paginas_vistas = [1];

        this.setState(state)
        this.props.esconderModal(state.pedidoModificado);
    }

    /**
     * Se ejecuta cada vez que se cambia una cantidad del artículo
     * @param: value. La cantidad que se introdujo
     * @param: record. El objeto al que se le está haciendo el cambio
     * @return: nada.
     */
    onChangeCantArticulo = (value, record) => {
        let state = { ...this.state };
        state.bloquearBtnEditar = false;

        if (value === "" || value === undefined || value === null) value = 0;
        value = Math.round(value);

        state.articulosPedido.forEach((obj, index) => {
            if (obj.codigo_proveedor === record.codigo_proveedor) {
                let objTemp = { ...obj }
                if (value === "" || value === undefined || value === null) value = 0;
                obj.cantidad_solicitada = value;
                
                if (value > 0 && value !== obj.cantidad_original) {
                    objTemp.cantidad_solicitada = value;
                    let finded = state.arrEditArticulos.indexOf(state.arrEditArticulos.find(x => x.id === objTemp.id));
                    if (finded === -1)
                    {
                        state.arrEditArticulos.push(objTemp);
                    }
                    else
                    {
                        state.arrEditArticulos[finded].cantidad_solicitada = value;
                    }
                }
                else {
                    let finded = state.arrEditArticulos.indexOf(state.arrEditArticulos.find(x => x.id === objTemp.id));
                    state.arrEditArticulos.splice(finded, 1)
                }
            }
        });

        if(state.arrEditArticulos.length === 0)
            state.bloquearBtnEditar = true;

        this.setState(state)
    }

    /* Validación para mostrar la confirmación de recibir */
    mostrarConfModificados = () => {
        let state = { ...this.state };
        
        if (state.arrEditArticulos.length) {
            state.mostrarModalModificados = true;

            this.setState(state)
            return
        }
    }

    /**
     * Función que se manda a llamar cuando se va a calificar
     * al proveedor
     */
    editarPedido = () => {
        let state = { ...this.state }
        let objEnviar = {};

        objEnviar.pedido = this.props.pedido_selected.id;
        objEnviar.articulos = state.arrEditArticulos;
        state.cargando = true;
        state.bloquearBtnEditar = true;
        state.mostrarModalModificados = false;
    
        this.setState(state, () =>{
            Pedidos.ActualizarArticulosSAP(objEnviar).then(response => {
                this.props.esconderModal();
                this.setState({ bloquearBtnEditar: false, cargando:false })
                openNotification("Se actualizó satisfactoriamente.", true)
            }).catch(err => {
                this.props.esconderModal();
                this.setState({ bloquearBtnEditar: false, cargando:false })
                openNotification("No se ha podido actualizar el artículo del pedido.", "Error al actualizar artículo", false)
            });
        });
    }

    render() {
        const columnasArticulos = [
            {
                title: "Código",
                dataIndex: "codigo_proveedor",
                key: "codigo_proveedor",
            },
            {
                title: "Descripción",
                dataIndex: "descripcion_articulo",
                key: "descripcion_articulo",
            },
            {
                title: "Estatus",
                dataIndex: "status",
                key: "status",
                render: estatus => (
                    <Tag
                        color={estatus === "Abierto" ? "#6fa8dcff" : estatus === "Terminado" ? "#092f50" : estatus === "Pendiente" ? "#d8b000" : estatus === "Planeado" ? "#3d85c6ff" : estatus === "Embarcado" ? "#0b5394ff" : ''}
                        key={estatus}>{estatus}
                    </Tag>
                )
            },
            {
                title: "UDMP",
                dataIndex: "unidad_medida",
                key: "unidad_medida",
            },
            {
                title: "Cant. Solicitada",
                dataIndex: "cantidad_solicitada",
                key: "cantidad_solicitada",
                render: (value, record) => (
                    <InputNumber
                        type="number"
                        formatter={value => String(value).replace(/[,.-]$/, '')}
                        parser={value => String(value).replace(/[,.-]$/, '')}
                        min={1}
                        maxLength={7}
                        onWheel={(e) => e.target.blur()}
                        className={record.bordeRojo ? "bordeRojoInput" : ""}
                        disabled={(record.disabled || record.status !== "Creado") ? true : false}
                        onChange={(cantidad) => this.onChangeCantArticulo(cantidad, record)}
                        defaultValue={record.cantidad_solicitada}
                        value={record.cantidad_solicitada}
                    />
                )
            }
        ]

        const columnasArtActualizados = [
            {
                title: "Código",
                dataIndex: "codigo_proveedor",
                key: "codigo_proveedor",
            },
            {
                title: "Descripción",
                dataIndex: "descripcion_articulo",
                key: "descripcion_articulo",
            },
            {
                title: "Cantidad",
                dataIndex: "cantidad_solicitada",
                key: "cantidad_solicitada",
            },
            {
                title: "UDMP",
                dataIndex: "unidad_medida",
                key: "unidad_medida",
            }
        ]

        return (
            <div>
                <Modal
                    title={this.props.pedido_selected !== null ? "Editar pedido número #" + (this.props.pedido_selected.pedido_sap !== null ? this.props.pedido_selected.pedido_sap : "") : ""}
                    onCancel={this.handleCancel}
                    visible={this.props.visible}
                    width={"75%"}
                    maskClosable={false}
                    centered={true}
                    footer={
                        [
                            <Button
                                className="btnCancelar"
                                key="back"
                                onClick={this.handleCancel}>
                                Regresar
                            </Button>,
                            <Button
                                className="btnVerCrearGuardar"
                                key="submit"
                                type="primary"
                                disabled={this.state.bloquearBtnEditar}
                                onClick={() => {
                                    this.mostrarConfModificados();
                                }}
                            >
                                Editar
                            </Button>
                        ]
                    }
                >
                    <Spin
                        tip="Cargando..."
                        indicator={<Icon type="loading" style={{ fontSize: 24, color: "#e0cbae" }} spin />}
                        spinning={this.state.cargando}
                        style={{ color: "#e0cbae", backgroundColor: "rgb(255,255,255,0.8)" }}>
                        <Table
                            size="small"
                            pagination={this.state.paginacion}
                            locale={{ emptyText: 'No se han encontrado resultados.' }}
                            rowKey={articulos => articulos.id}
                            rowClassName={(articulo) => articulo.disabled ? 'back-grey' : ''}
                            columns={columnasArticulos}
                            dataSource={this.state.articulosPedido}
                        />
                    </Spin>
                </Modal>
                <Modal
                    title={<p style={{ textAlign: "center", marginBottom: 0 }}>Aviso sobre artículos</p>}
                    onCancel={() => { this.setState({ mostrarModalModificados: false }) }}
                    centered={true}
                    width={"75%"}
                    visible={this.state.mostrarModalModificados}
                    maskClosable={false}
                    footer={[
                        <Button
                            className="btnCancelar"
                            key="back"
                            onClick={() => {
                                let state = { ...this.state };
                                state.mostrarModalModificados = false;
                                state.disableBtnHijos = false;
                                this.setState(state);
                            }}>
                            Regresar
                        </Button>,
                        <Button
                            className="btnVerCrearGuardar"
                            key="submit"
                            type="primary"
                            disabled={this.state.disableBtnHijos}
                            onClick={() => {
                                this.setState({ disableBtnHijos: true, cargando_hijos: true }, this.editarPedido)
                            }}
                        >
                            Continuar
                        </Button>
                    ]}
                >
                    <p style={{ textAlign: 'center' }}>Los siguientes artículos se están modificando las cantidades anteriormente solicitadas, ¿Esta seguro que desea continuar?</p>
                    <Table
                        size="small"
                        pagination={false}
                        locale={{ emptyText: 'No se han encontrado resultados.' }}
                        rowKey={(_, index) => index}
                        columns={columnasArtActualizados}
                        dataSource={this.state.arrEditArticulos}
                        scroll={{ y: 350 }}
                    />
                </Modal>
            </div>
        )
    }
}